import { render } from "./IconEye.vue?vue&type=template&id=4893b8ce"
import script from "./IconEye.vue?vue&type=script&lang=js"
export * from "./IconEye.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__